<div class="close closeModal">
  <a (click)="close()" title="cerrar"><span class="cross"></span><span class="sr-only">cerrar</span></a>
</div>
<div class="CalendarioBox">
  <div class="tituloSearch">
    {{'ELIGE_LA_FECHA' | translate}}
  </div>

  <div class="calendar__header">
    <div class="selectCustom calendar_select--month" title="Selecciona el mes">
      <img class="svg" src="assets/img/active-arrow.svg">
      <div class="current">{{currentDate.format('MMMM') | titlecase | translate}}</div>
      <div class="calendar_list_month hiddenList">
          <div class="pest">
              <div class="inner">
                <i class="top left"></i>
                <i class="top right"></i>
                <div class="colorBG"></div>
              </div>
            </div>
            <div class="cols">
              <div class="col">                
                <div class="calendar_link" *ngFor="let month of monthsFirstColumn" [ngClass]="{'selected': month === currentDate.format('MMMM'), 'disable': !checkForDisabledMonths(month)}" (click)="selectMonth(month)">{{month | titlecase }}</div>
                </div>
              <div class="col">
                  <div class="calendar_link" *ngFor="let month of monthsSecondColumn" [ngClass]="{'selected': month === currentDate.format('MMMM'), 'disable': !checkForDisabledMonths(month)}" (click)="selectMonth(month)">{{month | titlecase }}</div>
              </div>
            </div>
      </div>
    </div>
    <div class="selectCustom calendar_select--year" title="Seleccciona el año">
      <img class="svg" src="assets/img/active-arrow.svg">
      <div class="current">{{currentDate.format('YYYY')}}</div>
      <div class="calendar_list_day hiddenList">
        <div class="calendar_link" *ngFor="let year of getYears()" [ngClass]="{'selected': year.format('YYYY') === currentDate.format('YYYY')}" (click)="selectYear(year)">{{year.format('YYYY')}}</div>
      </div>
    </div>
    <div  class="calendar_nav--prev" data-nav="-1" role="button" aria-controls="date_demo__selectors--a_table" title="Mes anterior" (click)="prevMonth()">
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono prev">
    </div>
    <div class="calendar_nav--next" data-nav="1" role="button" aria-controls="date_demo__selectors--a_table" title="Próximo mes" (click)="nextMonth()">
      <img class="svg" src="assets/img/active-arrow.svg" alt="icono next">
    </div>
  </div>
  <table class="calendar_table">
    <thead>
      <tr>
        <th *ngFor="let name of dayNames" class="calendar_weekday" scope="col" title="{{name}}" >{{name | slice:0:3 }}</th>        
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let week of weeks">
        <td *ngFor="let day of week">
            <div *ngIf="!isSelectedMonth(day.mDate)" class="calendar_day calendar_day--outfocus">
                {{ day.mDate.date() }}
            </div>
            <div *ngIf="isSelectedMonth(day.mDate)" class="calendar_day calendar_day--infocus"
            [ngClass]="{ 'calendar_day--today': day.today, 
                         'calendar_day--outfocus': day.mDate.isBefore() && !day.today || day.disabled,
                         'calendar_day--highlighted': isSelected(day.mDate)}"
            (click)="selectDate(day)"
            >{{ day.mDate.date() }}</div>
        </td>
      </tr>
    </tbody>
  </table>

